module.exports = __webpack_public_path__ + "images/152_4096.jpg";